module.exports = __webpack_public_path__ + "static/circle-jp-flag-d604bdb0d9bf8be7dfed9ff3b8f20a6b.svg";